export default function logAnalyticsEvent(
  eventName: string,
  params: {
    googleAnalytics?: Record<string, any>;
    facebookPixel?: Record<string, any>;
  } = {},
) {
  if (typeof window !== "undefined") {
    // Log to Google Analytics
    if ((window as any)?.dataLayer) {
      // @ts-ignore
      window.dataLayer.push({
        event: eventName,
        ...params.googleAnalytics,
      });
    }

    // Log to Facebook Pixel
    // @ts-ignore
    if (window?.fbq) {
      // @ts-ignore
      window.fbq("trackCustom", eventName, params.facebookPixel);
    }
  }
}
